import React, { useCallback, useRef, useState, useEffect } from 'react'
import { SLowcodeList, STableActions, SActionBtn } from 'shj-components'
import { Button, Col, DatePicker, Row, Table, Tabs, Image } from 'antd'
import { cloneDeep, get } from 'lodash-es'
import request, { METHODS } from '@/api'
import { dfs } from '@/common/utils'
import { useFileUrlPrefix } from 'shj-utils'
import { getCurrentResources } from '@/services'
import styles from '../../index.module.less'

const recentlyVisited = (props: any) => {
  const [tabNameList, setTabNameList] = useState<Array>([])
  const [imagePrefix] = useFileUrlPrefix()
  useEffect(() => {
    initMenu()
  }, [])

  /**
   * 根据树子节点ID查找所有父节点ID
   * @param {array} dataSource 树形结构数据源
   * @param {number|string} key 子节点ID
   * @returns {array} 包含所有父节点ID的数组，按照从根节点到直接父节点的顺序排序
   */
  const findParentIds = (dataSource, key) => {
    const parentIds = [] // 用于存储所有父节点ID的数组
    // 定义一个递归函数，用于遍历整棵树并查找子节点的所有父节点
    const traverse = (node, key) => {
      if (node.key === key) {
        // 如果当前节点的ID等于子节点的ID，则表示已经找到了子节点，可以开始向上查找父节点
        parentIds.unshift({ path: node.path, name: node.name, flag: true })
        return true // 返回true表示已经找到了子节点
      }
      if (node.children) {
        // 如果当前节点有子节点，则继续遍历子节点
        for (const childNode of node.children) {
          if (traverse(childNode, key)) {
            // 如果在子节点中找到了子节点的父节点，则将当前节点的ID添加到父节点ID数组中，并返回true表示已经找到了子节点
            parentIds.unshift({
              path: node.path,
              name: node.name + '/',
              icon: imagePrefix + node.icon,
            })
            return true
          }
        }
      }
      return false // 如果当前节点不是子节点的父节点，则返回false
    }
    // 从根节点开始遍历整棵树，并调用递归函数查找子节点的所有父节点
    for (const node of dataSource) {
      if (traverse(node, key)) {
        // 如果在当前节点的子树中找到了子节点的父节点，则直接退出循环
        break
      }
    }
    return parentIds // 返回所有父节点ID的数组
  }

  const getCurrentResourcesList = () => {
    return getCurrentResources().then((resp: any) => {
      return resp.menu
    })
  }

  const treeData = data => {
    let tabList = JSON.parse(localStorage.getItem('tabList'))
    let arr = []
    let list = cloneDeep(data)
    dfs(list, (item: any) => {
      if (!item.children || !item.children.length) {
        arr.push(item)
      } else {
        arr.push(item)
      }
    })
    let nameList = []
    for (const item of arr) {
      for (const eve of tabList) {
        if (eve.id === item.key) {
          const parentNames = findParentIds(list, item.key)
          nameList.push(parentNames)
        }
      }
    }
    return nameList
  }

  const initMenu = async () => {
    let menuList = await getCurrentResourcesList()
    let tabList = JSON.parse(localStorage.getItem('tabList'))
    let list = await treeData(menuList)
    list.map((item, index) => {
      item.urlPath = `https://static.shjmall.cn/sass/recentlyVisited${index}.png`
    })
    setTabNameList(list)
  }

  return (
    <div style={{ backgroundColor: '#fff', height: '135px' }}>
      <div className={styles.titleBox}>
        <div className={styles.titleText}>最近访问</div>
      </div>
      <Row className={styles.visitList} gutter={[0, 15]}>
        {tabNameList && tabNameList.length > 0 ? (
          tabNameList.map((item, index) => {
            return (
              <Col span={8} className={styles.visitItem} key={index}>
                <img src={item.urlPath} className={styles.visitImg} />
                {item.map((eve, i) => {
                  return (
                    <div key={i} className={eve.flag ? styles.visitText : ''}>
                      {eve.name}
                    </div>
                  )
                })}
              </Col>
            )
          })
        ) : (
          <div
            style={{
              width: '100%',
              height: '100%',
              textAlign: 'center',
              lineHeight: '100%',
              color: '#666666',
              fontSize: '15px',
            }}
          >
            暂无访问记录
          </div>
        )}
      </Row>
    </div>
  )
}
export default recentlyVisited
